import env from 'common/env';

export async function getPaymentMethods() {
    const result = await fetch(`${env}/regie/get-means-of-payment`, {
        method: 'GET'
    })
        .then(res => (res.ok ? res.json() : false))
        .then(data => data)
        .catch(err => {
            console.error(err);
            throw "Une erreur est survenue lors de l'affichage des moyens de paiement.";
        });

    return result;
}

export async function getInvoice(id) {
    const result = await fetch(`${env}/manager/billing/invoices/${id}`)
        .then(response => (response.ok ? response.json() : false))
        .then(res => res)
        .catch(error => {
            console.error(error);
            throw 'Echec de la récupération de la facture';
        });

    return result;
}

export async function getHistory(id) {
    const result = await fetch(`${env}/manager/billing/invoices/${id}/history`)
        .then(response => (response.ok ? response.json() : false))
        .then(res => res)
        .catch(error => {
            console.error(error);
            throw 'Echec de la récupération de l\'historique de la facture';
        });

    return result;
}

export async function cancelPayment(id) {
    const result = await fetch(`${env}/manager/billing/invoices/${id}/cancel-payment`, {
        method: 'POST',
        body: new FormData()
    })
        .then(response => (response.ok ? response.json() : false))
        .then(res => res)
        .catch(error => {
            console.error(error);
            throw "Echec de l\'annulation du paiement de la facture";
        });

    return result;
}

export async function cancelBill(id) {
    const result = await fetch(`${env}/manager/billing/invoices/${id}/cancel`, {
        method: 'POST',
        body: new FormData()
    })
        .catch(error => {
            console.error(error);
            throw "Echec de l'annulation de la facture";
        });

    return result;
}

export async function update(id, payload) {

    const result = await fetch(`${env}/manager/billing/invoices/${id}`, {
        method: 'POST',
        body: JSON.stringify(payload)
    }).catch(error => {
        console.error(error);
        throw "Echec de la modification de la facture";
    });

    return result;
}

export function exportPdf(id) {
    window.open(`${env}/manager/billing/invoices/${id}/export.pdf`, '_blank');
}



